/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LocationContact model module.
* @module model/LocationContact
* @version 1.0.0
*/
export default class LocationContact {
    /**
    * Constructs a new <code>LocationContact</code>.
    * @alias module:model/LocationContact
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>LocationContact</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LocationContact} obj Optional instance to populate.
    * @return {module:model/LocationContact} The populated <code>LocationContact</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LocationContact();
                        
            
            if (data.hasOwnProperty('Type')) {
                obj['Type'] = ApiClient.convertToType(data['Type'], 'String');
            }
            if (data.hasOwnProperty('Value')) {
                obj['Value'] = ApiClient.convertToType(data['Value'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} Type
    */
    'Type' = undefined;
    /**
    * @member {String} Value
    */
    'Value' = undefined;




}
